<template>
  <a-card style="width:100%; height: 800px" class="bg-white">
    <div class="width-full height-full relative">
      <tk-flex middle between style="">
        <div class="font-14">粮虫数量</div>
      </tk-flex>
      <a-row>
        <a-col :span="14">
          <div style="height: 740px">
            <MapDrilling
              v-if="renderMap"
              :getMapDataByAdcode="getMapData"
              @changeList="changeList"
              @gotoInitProvinceSuccess="gotoInitProvinceSuccess"
              :initProvinceCodeName="initProvinceCodeName"
            />
          </div>
        </a-col>
        <a-col :span="10">
          <div
            style="height: 740px;overflow-y: auto; color: rgba(54, 59, 69, 1);"
          >
            <a-skeleton style="height: 100%" :loading="loading">
              <tk-flex
                middle
                center
                class="bg-white width-full desc-title"
                style="height: 54px; font-size: 14px; font-weight: 600; background-color: rgba(246, 249, 252, 1);"
              >
                <span>粮虫数量明细</span>
              </tk-flex>
              <a-descriptions bordered :column="2">
                <a-descriptions-item
                  :label="item.name"
                  v-for="(item, index) in showBugNumList"
                  :key="index"
                >
                  {{ item.value.toLocaleString() }}
                </a-descriptions-item>
              </a-descriptions>
            </a-skeleton>
          </div>
        </a-col>
      </a-row>
      <div
        class="width-full height-full absolute bg-white"
        style="top: 0; left: 0;"
        v-if="compLoading"
      >
        <a-skeleton />
      </div>
    </div>
  </a-card>
</template>
<script>
import MapDrilling from '../../mapDrilling/index'
import { EXISTING_SECOND_LAYER_REGION } from '../../mapDrilling/constant.js'
import { mapGetters } from 'vuex'
import { orderBy } from 'lodash'
import { formatCompact } from '../../../utils/format'

export default {
  components: {
    MapDrilling
  },
  data () {
    return {
      renderMap: false,
      initProvinceCodeName: '',
      compLoading: true,
      loading: false,
      bugNumList: []
    }
  },
  computed: {
    ...mapGetters(['userLevelTag']),
    showBugNumList () {
      return orderBy(this.bugNumList, ['value'], ['desc'])
    }
  },
  methods: {
    async getInitProvinceCodeName () {
      const res = await this.$tkParse.get('/settings/mapName')
      const index = EXISTING_SECOND_LAYER_REGION.findIndex(
        element => element.adcode === res.data
      )
      if (index > -1) {
        this.compLoading = true
        this.initProvinceCodeName = `${EXISTING_SECOND_LAYER_REGION[index].adcode}-${EXISTING_SECOND_LAYER_REGION[index].name}`
      } else {
        this.compLoading = false
      }
      this.renderMap = true
    },
    gotoInitProvinceSuccess () {
      this.compLoading = false
    },
    formatCompact,
    changeList (arr) {
      this.bugNumList = arr
    },
    async getMapData (arr) {
      const ret = await this.getBugNumByAdcodes(arr)
      return ret
    },
    async getBugNumByAdcodes (codes) {
      this.loading = true
      const promises = codes.map(element =>
        this.getBugNumByAdcode(element.adcode)
      )
      const res = await Promise.all(promises)
      const arr = codes.map((element, index) => ({
        ...element,
        value: res[index]
      }))
      this.loading = false
      this.bugNumList = arr
      return arr
    },
    async getBugNumByAdcode (code) {
      if (code) {
        const res = await this.$tkParse.get('/classes/grainWarehouse', {
          params: {
            where: {
              hierarchy: {
                $inQuery: {
                  where: {
                    tag: { $regex: '^' + this.userLevelTag }
                  },
                  className: 'hierarchy'
                }
              },
              $or: [
                {
                  address: code.toString()
                },
                {
                  cityCode: code.toString()
                },
                {
                  provinceCode: code.toString()
                }
              ]
            }
          }
        })
        return res.data.results.reduce(
          (num, element) => num + element.bugNum || 0,
          0
        )
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.getInitProvinceCodeName()
    // if (this.initProvinceCodeName) {
    //   this.compLoading = true
    // } else {
    //   this.compLoading = false
    // }
  }
}
</script>

<style lang="scss" scoped>
.echarts {
  width: 100%;
  height: 100%;
}
.desc-title {
  border: 1px solid rgb(229, 231, 235);
  border-bottom: none;
}
::v-deep .ant-descriptions-view {
  border-radius: 0 !important;
  .ant-descriptions-item-label {
    font-size: 14px;
    text-align: center;
    background-color: rgba(246, 249, 252, 1);
  }
  // .ant-descriptions-item-content {
  //   // text-align: center;
  // }
}
</style>
